import { IComparisonType } from '@shared/models/business/iComparison-type.model';
import { ICountry } from '@shared/models/business/iCountry.model';
import { ICurrency } from '@shared/models/business/iCurrency.model';
import { IRange } from '@shared/models/business/iRange.model';
import { IUnits } from '@shared/models/business/iUnits.model';

export class GlobalInformation {
	id: number | undefined;
	isImported: boolean;
	filename: string;
	companyName: string;
	contactMail: string;
	contactName: string;
	caseName: string;
	country: ICountry;
	currency: ICurrency;
	range: IRange;
	comparisonType: IComparisonType;
	unit: IUnits;
	isTco: boolean;
	isDetail: boolean;
	customerView: number;
	date: Date;
}
